<template>
  <div class="dialog-mask">
    <div class="dialog-container" :class="countainerClass">
      <div class="dialog-toolbar">
        <div>
          <h1 v-show="!loading" class="dialog-title">{{ dialogTitle }}</h1>
        </div>
        <button class="dialog close-button" @click="handleDialogClose">
          <cancel-icon />
        </button>
      </div>
      <div class="dialog-content-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
  body {
    overflow: hidden;
  }
  .dialog-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color:rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
    overflow-y: scroll;
  }
  .dialog-container {
    max-width: 700px;
    margin: 0px auto;
    margin-top: 100px;
    padding: 30px;
    background-color: #fff;
    border-radius: 10px;
  }
  @media screen and (max-width: 750px) {
    .dialog-container {
      margin: 16px;
    }
  }
  .dialog-toolbar {
    display: flex;
    justify-content: space-between;
  }
  .dialog-title {
    color: var(--primary-color);
    margin-top: 0;
  }
  .close-button {
    opacity: 0.5;
    background-color: white;
    width: 26px;
    height: 26px;
    padding: 4px;
    border: none;
  }
  .close-button:hover {
    border-radius: 50%;
    background-color: rgb(185, 183, 183);
  }
</style>

<script>
import CancelIcon from './icons/CancelIcon.vue';

export default {
  name: 'custom-dialog',
  props: {
    dialogTitle: {
      type: String,
      required: true,
    },
    handleDialogClose: {
      type: Function,
      required: true,
    },
    countainerClass: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    CancelIcon,
  },
  created() {
    document.body.style.overflow = 'hidden';
  },
  destroyed() {
    document.body.style.overflow = 'auto';
  },
};
</script>
